import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { GeneralCatalogViewModel } from 'src/app/model/general/general-catalog.view';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralConsultExaminationService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getPatient = (): Observable<number> =>
    this.store.select('general', 'consult', 'patient');

  loadExaminations = (
    turn: number,
    patient: number,
    readonly: boolean
  ): Observable<GeneralCatalogViewModel[]> =>
    this.rest.get({
      url: `${environment.endpoints.general}/physical-examination/{turn}/{patient}`,
      urlParams: { turn, patient },
      params: { readonly },
    });

  isSaving = (): Observable<boolean> =>
    this.store.select('general', 'consult', 'saving');

  save = (
    body: GeneralCatalogViewModel[]
  ): Observable<GeneralCatalogViewModel[]> =>
    this.rest
      .post({
        url: `${environment.endpoints.general}/physical-examination`,
        body,
      })
      .pipe(
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        )
      );

  addToSaved = (value: number = 1) =>
    this.store.dispatch(generalConsultActions.addToSavedAction({ value }));
}
